<mat-card *ngIf="!loading" class="mcd-card">
  <mat-card-header class="mcd-card-header">
    <mat-card-title class="mcd-card-title" *ngIf="!isEditMode">
      Add Global Equipment Standard
    </mat-card-title>
    <mat-card-title class="mcd-card-title" *ngIf="isEditMode">
      Update Global Equipment Standard
    </mat-card-title>
  </mat-card-header>
  <div class="mat-card-wrapper" style="background-color: #f3f3f3">
    <mat-card-content class="mcd-card-content" style="background-color: #f3f3f3; margin-bottom: 20px">
      <form [formGroup]="addEquipmentStandardForm">
        <div class="mcd-edit-form mcd-grbes-form">
          <div style="margin: auto">
            <div style="
                border: 1px solid #a0a0a04d;
                padding: 0 0 14px 0;
                background-color: #ffffff;
                border-radius: 8px;
              ">
              <div>
                <div style="
                    font-size: 15px;
                    font-weight: 650;

                    color: #4d5258;
                  ">
                  <p style="margin: 0; padding: 16px 24px">
                    {{
                    selectedEquipmentClass
                    ? selectedEquipmentClass
                    : "Which Class of Equipment would you like to Add ?"
                    }}
                  </p>
                  <hr style="
                      color: #a0a0a04d;
                      opacity: 1;
                      font-weight: 700;
                      margin: 0;
                    " />
                </div>
                <div class="eqipmentClass">
                  <app-stepper [steps]="formSteps"></app-stepper>
                </div>
                <div class="col-12" style="margin: auto">
                  <mat-stepper (selectionChange)="onStepChange($event)" [selectedIndex]="currentSTepIndex" linear
                    labelPosition="bottom" #stepper (selectionChange)="onStepChange($event)"
                    style="margin-bottom: 10px">
                    <mat-step>
                      <ng-template matStepLabel style="color: #4d5258; font-weight: bold">Standard Type</ng-template>

                      <div style="
                          display: grid;
                          grid-template-columns: repeat(2, 1fr);
                          gap: 24px;
                          width: 75%;
                          margin: auto;
                        ">
                        <div *ngFor="let item of classEquipment">
                          <div *ngIf="!isEditMode" style="padding: 20px" class="card">
                            <span class="nav-icon gbs"></span>

                            <h3 style="
                                font-size: 16px;
                                font-weight: 900;
                                color: #4d5258;
                                text-align: left;
                              ">
                              {{ item.name }}
                            </h3>
                            <p style="color: #696f77" style="margin-bottom: 20px; font-size: 13px">
                              International norms and codes that govern how
                              buildings are designed, constructed, and operated
                            </p>
                            <button mat-raised-button style="
                                background-color: #3f51b51a;
                                color: #3f51b5;
                                font-weight: 600;
                                width: fit-content;
                              " (click)="
                                handleClassSelection(
                                  item.name,
                                  item.id,
                                  stepper
                                )
                              ">
                              Add {{ item.name }} Equipment
                            </button>
                          </div>
                        </div>
                      </div>
                      <div *ngIf="isEditMode" style="
                          display: grid;
                          grid-template-columns: repeat(2, 1fr);
                          gap: 20px;
                          width: 75%;
                          margin: auto;
                        ">
                        <div style="padding: 20px" class="card">
                          <span class="nav-icon gbs"></span>

                          <h3 style="
                              font-size: 16px;
                              font-weight: 900;
                              color: #4d5258;
                              text-align: left;
                            ">
                            {{ equipmentStandard.equipmentClassType.name }}
                          </h3>
                          <p style="color: #696f77">
                            International norms and codes that govern how
                            buildings are designed, constructed, and operated
                          </p>
                          <button mat-raised-button style="
                              background-color: #3f51b51a;
                              color: #3f51b5;
                              font-weight: 600;
                            " (click)="
                              handleClassSelection(
                                equipmentStandard.equipmentClassType.name,
                                equipmentStandard.equipmentClassType.id,
                                stepper
                              )
                            ">
                            Edit
                            {{ equipmentStandard.equipmentClassType.name }}
                            Equipment
                          </button>
                        </div>
                      </div>
                    </mat-step>

                    <mat-step [stepControl]="step1Group">
                      <ng-template matStepLabel>Category and Location</ng-template>
                      <div class="col-9" style="margin: auto">
                        <div>
                          <div>
                            <label for="operationsCategory" style="
                                font-weight: 500;
                                color: #595a6c;
                                margin-bottom: 3px;
                              ">Title*
                              <span matTooltip="Please provide a title for the equipment" style="
                                  background-image: url(&quot;/assets/images/Vector.svg&quot;);
                                  background-repeat: no-repeat;
                                  background-size: auto;
                                  background-position: center;

                                  padding: 10px;
                                "></span></label>
                            <div class="title">
                              <input [ngStyle]="{
                                  'margin-bottom':
                                    addEquipmentStandardForm.get('title')
                                      ?.touched &&
                                    addEquipmentStandardForm
                                      .get('title')
                                      ?.hasError('required')
                                      ? '0px'
                                      : '30px',
                                }" name="title" formControlName="title" required placeholder="Enter Title"
                                (paste)="onPasteCleanup('title')" class="form-title" />
                              <mat-error *ngIf="
                                  addEquipmentStandardForm.get('title')
                                    .touched &&
                                  addEquipmentStandardForm
                                    .get('title')
                                    .hasError('required')
                                ">
                                Title is required
                              </mat-error>
                            </div>
                          </div>
                        </div>

                        <div [ngStyle]="{
                            'margin-bottom':
                              addEquipmentStandardForm.get('equipmentTypeId')
                                ?.touched &&
                              addEquipmentStandardForm
                                .get('equipmentTypeId')
                                ?.hasError('required')
                                ? '45px'
                                : '75px',
                          }">
                          <label for="operationsCategory" style="
                              font-weight: 500;
                              color: #595a6c;
                              margin-bottom: 3px;
                            ">Equipment Type*
                            <span matTooltip="Select the appropriate equipment type for your item - i.e Egg Cooker"
                              style="
                                background-image: url(&quot;/assets/images/Vector.svg&quot;);
                                background-repeat: no-repeat;
                                background-size: auto;
                                background-position: center;

                                padding: 10px;
                              "></span>
                          </label>
                          <div class="category-dropdown-wrapper">
                            <ng-multiselect-dropdown [ngClass]="{
                                'invalid-border':
                                  step1Group.get('equipmentTypeId')?.invalid &&
                                  step1Group.get('equipmentTypeId')?.touched,
                              }" class="dropdown-list" [placeholder]="" [settings]="equipmentdropdownSettings"
                              [data]="equipMentDropdownList" [(ngModel)]="selectedEquipmentType"
                              (onSelect)="onEquipmentSelect($event)" (onDeSelect)="onEquipmentDeSelect($event)"
                              [ngModelOptions]="{ standalone: true }">
                            </ng-multiselect-dropdown>
                          </div>
                        </div>
                        <div style="font-size: x-small; margin-bottom: 20px">
                          <mat-error *ngIf="
                              addEquipmentStandardForm.get('equipmentTypeId')
                                .touched &&
                              addEquipmentStandardForm
                                .get('equipmentTypeId')
                                .hasError('required')
                            ">
                            Equipment Type is required
                          </mat-error>
                        </div>

                        <div [ngStyle]="{
                            'margin-bottom':
                              addEquipmentStandardForm.get('supplierId')
                                ?.touched &&
                              addEquipmentStandardForm
                                .get('supplierId')
                                ?.hasError('required')
                                ? '45px'
                                : '75px',
                          }">
                          <label for="operationsCategory" style="
                              font-weight: 500;
                              color: #595a6c;
                              margin-bottom: 3px;
                            ">Supplier*
                            <span matTooltip="Select the approved supplier " style="
                                background-image: url(&quot;/assets/images/Vector.svg&quot;);
                                background-repeat: no-repeat;
                                background-size: auto;
                                background-position: center;

                                padding: 10px;
                              "></span>
                          </label>
                          <div class="category-dropdown-wrapper">
                            <ng-multiselect-dropdown [ngClass]="{
                                'invalid-border':
                                  step1Group.get('supplierId')?.invalid &&
                                  step1Group.get('supplierId')?.touched,
                              }" class="dropdown-list" [placeholder]="" [settings]="equipmentdropdownSettings"
                              [data]="supplierDropdownList" [(ngModel)]="selectedSupplier"
                              (onSelect)="onSupplierSelect($event)" (onDeSelect)="onSupplierDeSelect($event)"
                              [ngModelOptions]="{ standalone: true }">
                            </ng-multiselect-dropdown>
                          </div>
                        </div>
                        <div style="font-size: x-small; margin-bottom: 20px">
                          <mat-error *ngIf="
                              addEquipmentStandardForm.get('supplierId')
                                .touched &&
                              addEquipmentStandardForm
                                .get('supplierId')
                                .hasError('required')
                            ">
                            supplier is required
                          </mat-error>
                        </div>

                        <div style="margin-bottom: 30px">
                          <div>
                            <label for="operationsCategory" style="
                                font-weight: 500;
                                color: #595a6c;
                                margin-bottom: 3px;
                              ">Model*
                              <span matTooltip="Share the specific model number " style="
                                  background-image: url(&quot;/assets/images/Vector.svg&quot;);
                                  background-repeat: no-repeat;
                                  background-size: auto;
                                  background-position: center;

                                  padding: 10px;
                                "></span></label>
                            <div class="title">
                              <input name="title" formControlName="model" required placeholder="Enter model"
                                (paste)="onPasteCleanup('title')" class="form-title" />
                              <mat-error *ngIf="
                                  addEquipmentStandardForm.get('model')
                                    .touched &&
                                  addEquipmentStandardForm
                                    .get('model')
                                    .hasError('required')
                                ">
                                Model is required
                              </mat-error>
                            </div>
                          </div>
                        </div>

                        <div style="margin-top: 40px">
                          <button matButton matStepperPrevious (click)="previousStep()" style="
                              width: 100px;
                              height: 39px;
                              color: #4d5258;
                              font-weight: 500;
                              border-radius: 5px;
                              border: 1px solid #c1c6cd;
                              background-color: #ffffff;
                              margin-right: 10px;
                            ">
                            <img src="/assets/images/leftarrow.svg" alt="arrow" style="margin-right: 5px" />Back
                          </button>
                          <button (click)="nextStep()" matButton matStepperNext style="
                              width: 100px;
                              height: 39px;
                              color: #4d5258;
                              font-weight: 500;
                              border-radius: 5px;
                              border: 1px solid #c1c6cd;
                              background-color: #ffffff;
                              margin-right: 10px;
                            ">
                            Next<img src="/assets/images/rightarrow.svg" alt="arrow" style="margin-left: 5px" />
                          </button>
                        </div>
                      </div>
                    </mat-step>

                    <mat-step [stepControl]="step2Group">
                      <ng-template matStepLabel>Locations & Images</ng-template>

                      <div class="col-9" style="margin: auto">
                        <div *ngIf="
                            addEquipmentStandardForm['controls'].classTypeId
                              .value == 2
                          " class="dropDown-bottom-Space">
                          <label for="operationsCategory" style="
                              font-weight: 500;
                              color: #595a6c;
                              margin-bottom: 3px;
                            ">Country*
                            <span matTooltip="Info about the action" style="
                                background-image: url(&quot;/assets/images/Vector.svg&quot;);
                                background-repeat: no-repeat;
                                background-size: auto;
                                background-position: center;

                                padding: 10px;
                              "></span>
                          </label>
                          <div class="category-dropdown-wrapper">
                            <ng-multiselect-dropdown class="dropdown-list" [placeholder]=""
                              [settings]="equipmentdropdownSettings" [data]="countryDropdownList"
                              [(ngModel)]="selectedCountry" (onSelect)="SelectCountry($event)"
                              [ngModelOptions]="{ standalone: true }">
                            </ng-multiselect-dropdown>
                            <mat-error *ngIf="
                                addEquipmentStandardForm.get('countryId')
                                  .touched &&
                                addEquipmentStandardForm
                                  .get('countryId')
                                  .hasError('required')
                              ">
                              Country is required
                            </mat-error>
                          </div>
                        </div>

                        <div *ngIf="
                            addEquipmentStandardForm['controls'].classTypeId
                              .value == 1
                          " style="display: flex; justify-content: space-between" class="dates newForm">
                          <div style="width: 48%">
                            <label style="
                                font-weight: 500;
                                color: #595a6c;
                                margin-bottom: 3px;
                              ">Approved for use*
                              <span
                                matTooltip="This is the date that the Equipment is approved for use in McDonald's restaurants "
                                style="
                                  background-image: url(&quot;/assets/images/Vector.svg&quot;);
                                  background-repeat: no-repeat;
                                  background-size: auto;
                                  background-position: center;

                                  padding: 10px;
                                "></span></label>
                            <mat-form-field>
                              <input matInput [matDatepicker]="picker2" formControlName="effectiveFrom"
                                (focus)="closeLocationDropdown()" (click)="closeLocationDropdown()" />
                              <div matSuffix (click)="closeLocationDropdown()"
                                style="display: flex; align-items: center;">
                                <mat-datepicker-toggle [for]="picker2">
                                  <img matDatepickerToggleIcon src="../../assets/images/date-calender.svg"
                                    alt="Calendar" style="
                                      width: 20px;
                                      height: 20px;
                                      cursor: pointer;
                                      margin-bottom: 2px;
                                    " />
                                </mat-datepicker-toggle>
                              </div>
                              <mat-datepicker #picker2 (opened)="closeLocationDropdown()"
                                style="height: 30px; width: 30px"></mat-datepicker>
                              <mat-error *ngIf="
                                  addEquipmentStandardForm.get('effectiveFrom')
                                    .touched &&
                                  addEquipmentStandardForm
                                    .get('effectiveFrom')
                                    .hasError('required')
                                ">
                                Date is required
                              </mat-error>
                            </mat-form-field>
                          </div>

                          <div style="width: 48%">
                            <label style="
                                font-weight: 500;
                                color: #595a6c;
                                margin-bottom: 3px;
                              ">Obsolete Date*
                              <span
                                matTooltip="This is the date that the equipment reaches 'end of life' and is no longer compliant with the Global Minimum standard "
                                style="
                                  background-image: url(&quot;/assets/images/Vector.svg&quot;);
                                  background-repeat: no-repeat;
                                  background-size: auto;
                                  background-position: center;

                                  padding: 10px;
                                "></span></label>
                            <mat-form-field>
                              <input matInput [matDatepicker]="picker" formControlName="obsoleteDate"
                                (focus)="closeLocationDropdown()" (click)="closeLocationDropdown()" />
                              <div matSuffix (click)="closeLocationDropdown()"
                                style="display: flex; align-items: center;">
                                <mat-datepicker-toggle [for]="picker">
                                  <img matDatepickerToggleIcon src="../../assets/images/date-calender.svg"
                                    alt="Calendar" style="
                                      width: 20px;
                                      height: 20px;
                                      cursor: pointer;
                                      margin-bottom: 2px;
                                    " />
                                </mat-datepicker-toggle>
                              </div>
                              <mat-datepicker #picker (opened)="closeLocationDropdown()"></mat-datepicker>
                              <mat-error *ngIf="
                                  addEquipmentStandardForm.get('obsoleteDate')
                                    .touched &&
                                  addEquipmentStandardForm
                                    .get('obsoleteDate')
                                    .hasError('required')
                                ">
                                Date is required
                              </mat-error>
                            </mat-form-field>
                          </div>
                        </div>

                        <div [ngStyle]="{
                            'margin-bottom':
                              addEquipmentStandardForm.get('locationTypeId')
                                ?.touched &&
                              addEquipmentStandardForm
                                .get('locationTypeId')
                                ?.hasError('required')
                                ? '45px'
                                : '75px',
                          }">
                          <div style="
                              display: flex;
                              justify-content: space-between;
                            ">
                            <label for="operationsCategory" style="
                                font-weight: 500;
                                color: #595a6c;
                                margin-bottom: 3px;
                              ">Location*
                              <span matTooltip="Please share where this equipment may be located in the restaurant "
                                style="
                                  background-image: url(&quot;/assets/images/Vector.svg&quot;);
                                  background-repeat: no-repeat;
                                  background-size: auto;
                                  background-position: center;

                                  padding: 10px;
                                "></span></label>
                            <button *ngIf="selectedLocations.length > 1" style="
                                background: transparent;
                                border: none;
                                background-color: white;
                              " (click)="clearAllSelected()">
                              clear all
                            </button>
                          </div>

                          <div style="max-height: 550px" class="multiLocations">
                            <ng-multiselect-dropdown [ngClass]="{
                                'invalid-border':
                                  step2Group.get('locationTypeId')?.invalid &&
                                  step2Group.get('locationTypeId')?.touched,
                              }" #locationDropdown class="dropdown-list" [placeholder]=""
                              [(ngModel)]="selectedLocations" [settings]="dropdownSettings"
                              [data]="LocationsdropdownList" (onSelect)="onItemSelect($event)"
                              (onDeSelect)="onItemSelect($event)" (onSelectAll)="onSelectAll($event)"
                              [ngModelOptions]="{ standalone: true }" (onDropDownOpen)="onDropdownOpen()">
                            </ng-multiselect-dropdown>
                          </div>
                        </div>
                        <div>
                          <mat-error *ngIf="
                              addEquipmentStandardForm.get('locationTypeId')
                                .touched &&
                              addEquipmentStandardForm
                                .get('locationTypeId')
                                .hasError('required')
                            " style="font-size: x-small; margin-bottom: 20px">
                            Location is required
                          </mat-error>
                        </div>

                        <div *ngIf="showSublocationField()" [ngStyle]="{
                            'margin-bottom':
                              addEquipmentStandardForm.get('subLocationTypeId')
                                ?.touched &&
                              addEquipmentStandardForm
                                .get('subLocationTypeId')
                                ?.hasError('required')
                                ? '45px'
                                : '75px',
                          }">
                          <label for="operationsCategory" style="
                              font-weight: 500;
                              color: #595a6c;
                              margin-bottom: 3px;
                            ">Sub-Location*
                            <span matTooltip="Provide additional information on the location " style="
                                background-image: url(&quot;/assets/images/Vector.svg&quot;);
                                background-repeat: no-repeat;
                                background-size: auto;
                                background-position: center;

                                padding: 10px;
                              "></span></label>
                          <div class="category-dropdown-wrapper">
                            <ng-multiselect-dropdown [ngClass]="{
                                'invalid-border':
                                  step2Group.get('subLocationTypeId')
                                    ?.invalid &&
                                  step2Group.get('subLocationTypeId')?.touched,
                               }" #subLocationDropdown class="dropdown-list" [(ngModel)]="subLocationselected"
                              [placeholder]="" [settings]="equipmentdropdownSettings" [data]="sublocationDropdownList"
                              (onSelect)="onSubLocationSelect($event)" (onDeSelect)="onSubLocationDeSelect($event)"
                              (onSelectAll)="onSelectAll($event)" [ngModelOptions]="{ standalone: true }">
                            </ng-multiselect-dropdown>
                          </div>
                        </div>
                        <div style="font-size: x-small; margin-bottom: 20px">
                          <mat-error *ngIf="
                              addEquipmentStandardForm.get('subLocationTypeId')
                                .touched &&
                              addEquipmentStandardForm
                                .get('subLocationTypeId')
                                .hasError('required')
                            ">
                            Sub-Location is required
                          </mat-error>
                        </div>

                        <div class="">
                          <label for="operationsCategory" style="
                              font-weight: 500;
                              color: #595a6c;
                              margin-bottom: 3px;
                            ">Description *
                            <span matTooltip="Provide 1-2 sentences describing requirements for  equipment." style="
                                background-image: url(&quot;/assets/images/Vector.svg&quot;);
                                background-repeat: no-repeat;
                                background-size: auto;
                                background-position: center;

                                padding: 10px;
                              "></span></label>
                          <div class="description">
                            <textarea class="textarea" [ngStyle]="{
                                'margin-bottom':
                                  addEquipmentStandardForm.get('description')
                                    ?.touched &&
                                  addEquipmentStandardForm
                                    .get('description')
                                    ?.hasError('required')
                                    ? '0px'
                                    : '30px',
                              }" style="height: 120px" placeholder="Enter Description" matInput name="description"
                              formControlName="description" required (paste)="onPasteCleanup('description')"></textarea>

                            <mat-error *ngIf="
                                addEquipmentStandardForm.get('description')
                                  .touched &&
                                addEquipmentStandardForm
                                  .get('description')
                                  .hasError('required')
                              ">
                              Description is required
                            </mat-error>
                          </div>
                          <!-- <mat-form-field>
                        
                        </mat-form-field> -->
                        </div>

                        <div>
                          <label for="operationsCategory" style="
                              font-weight: 500;
                              color: #595a6c;
                              margin-bottom: 3px;
                            ">Equipment Image*
                            <span matTooltip="Attach a photo of the equipment (JPEG, BMP, PNG files)" style="
                                background-image: url(&quot;/assets/images/Vector.svg&quot;);
                                background-repeat: no-repeat;
                                background-size: auto;
                                background-position: center;

                                padding: 10px;
                              "></span></label>
                          <div class="imageBox" [ngClass]="{
                              'invalid-border':
                                step2Group.get('image')?.invalid &&
                                step2Group.get('image')?.touched,
                            }">
                            <div>
                              <div class="row attachements" (click)="equipmentImage.click()">
                                <div style="
                                    margin: auto;
                                    text-align: center;
                                    padding: 10px;
                                  " *ngIf="
                                    !equipmentStandard.imageAttachment?.fileName
                                  ">
                                  <p style="
                                      color: #3f51b5;
                                      font-size: 14px;
                                      margin: 0;
                                    ">
                                    Choose Image
                                  </p>
                                  <p style="
                                      margin: 0;
                                      font-size: 12px;
                                      color: #696f77;
                                    ">
                                    *Only JPEG, PNG, & BMP Files Allowed
                                  </p>
                                </div>
                                <div class="uploaded-file" *ngIf="
                                    equipmentStandard.imageAttachment?.fileName
                                  " style="
                                    text-align: center;
                                    margin: auto;
                                    padding: 12px;
                                    display: flex;
                                  ">
                                  <div style="position: relative">
                                    <div style="
                                        border: 4px solid white;
                                        margin-left: 12px;
                                        height: 100px;
                                        width: 100px;

                                        border-radius: 6px;
                                      ">
                                      <img
                                        [src]="equipmentStandard.imageAttachmentContentAsBase64 || equipmentStandard.imageAttachment?.image || (equipmentStandard.imageAttachment?.attachmentContent ? ((equipmentStandard.imageAttachment?.mime || 'data:image/png;base64,') + equipmentStandard.imageAttachment?.attachmentContent) : '')"
                                        style="
                                          width: 100%;
                                          height: 100%;
                                          object-fit: cover;
                                          border-radius: 4px;
                                        " />
                                    </div>
                                    <div style="
                                        top: 0;
                                        position: absolute;
                                        right: 0;
                                        padding: 4px;
                                      ">
                                      <span *ngIf="
                                          equipmentStandard.imageAttachment
                                            ?.fileName
                                        ">
                                        <a href="javascript:void(0);" (click)="onRemoveImage()">
                                          <i class="material-icons delete-icon">
                                            cancel
                                          </i>
                                        </a>
                                      </span>
                                    </div>
                                  </div>
                                  <div style="align-content: center">
                                    <!-- <span class="file-name">
                                    <a
                                      href="javascript:void(0);"
                                      (click)="
                                        onDownloadSelectedImage(
                                          equipmentStandard?.imageAttachment?.id
                                        )
                                      "
                                      >{{
                                        equipmentStandard.imageAttachment
                                          ?.fileName
                                      }}</a
                                    >
                                  </span> -->
                                  </div>
                                </div>
                                <!-- <mat-label *ngIf="
                                    equipmentStandard.imageAttachment
                                      ?.fileName && isEditMode
                                  ">Image File</mat-label> -->
                                <!-- <div class="uploaded-file">
                                  <span class="file-name">
                                    <a
                                      href="javascript:void(0);"
                                      (click)="
                                        onDownloadSelectedImage(
                                          equipmentStandard?.imageAttachment?.id
                                        )
                                      "
                                      >{{
                                        equipmentStandard.imageAttachment
                                          ?.fileName
                                      }}</a
                                    >
                                  </span>
                                  <span
                                    *ngIf="
                                      equipmentStandard.imageAttachment
                                        ?.fileName
                                    "
                                  >
                                    <a
                                      href="javascript:void(0);"
                                      (click)="onRemoveImage()"
                                    >
                                      <i class="material-icons delete-icon">
                                        cancel
                                      </i>
                                    </a>
                                  </span>
                                </div> -->
                                <input hidden type="file" (change)="onSelectImage($event)" #equipmentImage />
                              </div>
                            </div>
                          </div>
                          <div>
                            <mat-error class="mat-error-left-label" *ngIf="invalidImage">
                              Invalid file type.
                            </mat-error>
                            <mat-error class="mat-error-left-label" *ngIf="invalidImageRes">
                              Invalid image resolution.
                            </mat-error>
                            <mat-error style="font-size: x-small" *ngIf="
                                addEquipmentStandardForm.get('image').touched &&
                                addEquipmentStandardForm.get('image').invalid
                              ">
                              Equipment image is required
                            </mat-error>
                          </div>
                        </div>

                        <div style="margin-top: 40px">
                          <button matButton matStepperPrevious (click)="previousStep()" style="
                              width: 100px;
                              height: 39px;
                              color: #4d5258;
                              font-weight: 500;
                              border-radius: 5px;
                              border: 1px solid #c1c6cd;
                              background-color: #ffffff;
                              margin-right: 10px;
                            ">
                            <img src="/assets/images/leftarrow.svg" alt="arrow" style="margin-right: 5px" />Back
                          </button>
                          <button (click)="nextStep()" matButton matStepperNext style="
                              width: 100px;
                              height: 39px;
                              color: #4d5258;
                              font-weight: 500;
                              border-radius: 5px;
                              border: 1px solid #c1c6cd;
                              background-color: #ffffff;
                              margin-right: 10px;
                            ">
                            Next<img src="/assets/images/rightarrow.svg" alt="arrow" style="margin-left: 5px" />
                          </button>
                        </div>
                      </div>
                    </mat-step>

                    <mat-step [stepControl]="step3Group">
                      <div class="col-9" style="margin: auto">
                        <div style="margin-bottom: 30px">
                          <label for="operationsCategory" style="
                              font-weight: 500;
                              color: #595a6c;
                              margin-bottom: 3px;
                            ">Details*
                            <span matTooltip="Please share details" style="
                                background-image: url(&quot;/assets/images/Vector.svg&quot;);
                                background-repeat: no-repeat;
                                background-size: auto;
                                background-position: center;

                                padding: 10px;
                              "></span></label>
                          <quill-editor [ngClass]="{
                              'invalid-note':
                                step3Group.get('note')?.invalid &&
                                step3Group.get('note')?.touched,
                            }" name="note" formControlName="note" class="quill-editor-css"
                            (onEditorCreated)="onEditorCreated($event)">
                          </quill-editor>
                          <!-- <mat-error
                            *ngIf="
                              step3Group.get('note').touched &&
                              step3Group.get('note').hasError('required')
                            "
                            style="font-size: x-small"
                          >
                            Details required
                          </mat-error> -->
                        </div>

                        <div>
                          <div>
                            <label for="operationsCategory" style="
                                font-weight: 500;
                                color: #595a6c;
                                margin-bottom: 3px;
                              ">Resources and Supportive Information
                              <span
                                matTooltip="Please provide links to any Globally Approved Hardware or Equipment that enable restaurants to meet the Global Minimum Standard "
                                style="
                                  background-image: url(&quot;/assets/images/Vector.svg&quot;);
                                  background-repeat: no-repeat;
                                  background-size: auto;
                                  background-position: center;

                                  padding: 10px;
                                "></span></label>
                          </div>
                          <div formArrayName="resourceLinks1">
                            <div *ngFor="
                                let link of resourceLinks1.controls;
                                let i = index
                              " [formGroupName]="i" class="resourceBlock" [ngStyle]="{
                                'margin-bottom':
                                  addEquipmentStandardForm.get(
                                    'linksFieldValid'
                                  )?.touched ||
                                  addEquipmentStandardForm.get(
                                    'linksFieldValid'
                                  )?.invalid
                                    ? '20px'
                                    : '20px',
                              }">
                              <div style="position: relative; flex: 1" class="resourceLinkInValid" [ngClass]="{
                                  invalidborder:
                                    link.get('url')?.value == '' &&
                                    link.get('title')?.value,
                                }">
                                <input type="url" formControlName="url" placeholder="Paste Link here..."
                                  class="resource-input" (paste)="onPasteLink($event, link)"
                                  (keydown)="disableTyping($event)" />

                                <img *ngIf="link.get('url')?.value === ''" alt="mail" (click)="pasteLink(link)"
                                  src="/assets/images/Group (1).svg" style="
                                    position: absolute;
                                    right: 10px;
                                    top: 50%;
                                    transform: translateY(-50%);
                                    width: 18px;
                                    height: 18px;
                                    cursor: pointer;
                                  " />
                                <svg (click)="openLink(link.get('url')?.value)" *ngIf="link.get('url')?.value !== ''"
                                  xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor"
                                  class="bi bi-box-arrow-up-right link-svg" viewBox="0 0 16 16">
                                  <path fill-rule="evenodd"
                                    d="M8.636 3.5a.5.5 0 0 0-.5-.5H1.5A1.5 1.5 0 0 0 0 4.5v10A1.5 1.5 0 0 0 1.5 16h10a1.5 1.5 0 0 0 1.5-1.5V7.864a.5.5 0 0 0-1 0V14.5a.5.5 0 0 1-.5.5h-10a.5.5 0 0 1-.5-.5v-10a.5.5 0 0 1 .5-.5h6.636a.5.5 0 0 0 .5-.5" />
                                  <path fill-rule="evenodd"
                                    d="M16 .5a.5.5 0 0 0-.5-.5h-5a.5.5 0 0 0 0 1h3.793L6.146 9.146a.5.5 0 1 0 .708.708L15 1.707V5.5a.5.5 0 0 0 1 0z" />
                                </svg>
                                <div style="position: absolute">
                                  <mat-error *ngIf="
                                      link.get('title')?.value &&
                                      link.get('url')?.value === ''
                                    " style="font-size: x-small">
                                    Url is required, if title is provided.
                                  </mat-error>
                                </div>
                                <!-- <img
                               class="nextWindow"
                               *ngIf="link.url != '' "
                                alt="mail"
                                (click)="pasteLink(link)"
                                src="/assets/images/Right Link (1).svg"
                                style="
                                  position: absolute;
                                  right: 10px;
                                  top: 50%;
                                  transform: translateY(-50%);
                                  width: 25px;
                                  height: 25px;
                                  cursor: pointer;
                                "
                              /> -->
                              </div>

                              <div style="position: relative; flex: 2" class="resourceTitleInValid" [ngClass]="{
                                  invalidborder:
                                    link.get('title')?.value == '' &&
                                    link.get('url')?.value,
                                }">
                                <input type="text" (input)="onEnterResourceTitle(link)" formControlName="title"
                                  placeholder="Enter Title" class="resource-input resource-description" />
                                <img (click)="removeLink(i)" alt="link" src="/assets/images/Right Link.svg" style="
                                    position: absolute;
                                    right: 10px;
                                    top: 50%;
                                    transform: translateY(-50%);
                                    width: 30px;
                                    height: 30px;
                                    cursor: pointer;
                                  " />
                                <div style="position: absolute">
                                  <mat-error *ngIf="
                                      link.get('url')?.value &&
                                      link.get('title')?.value === ''
                                    " style="font-size: x-small">
                                    Title is required, if url is provided.
                                  </mat-error>
                                </div>
                              </div>
                            </div>
                          </div>

                          <button style="
                              border: 1px solid #ced2ed;
                              padding: 6px 10px 6px 10px;
                              background-color: #f1f3fb;
                              color: #5a69bf;
                              border-radius: 6px;
                              font-weight: 500;
                              margin-bottom: 10px;
                            " type="button" class="add-link-btn" (click)="addLinks()">
                            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                              stroke-width="2">
                              <line x1="12" y1="5" x2="12" y2="19"></line>
                              <line x1="5" y1="12" x2="19" y2="12"></line>
                            </svg>
                            Add Another Link
                          </button>
                        </div>

                        <div style="margin-top: 40px">
                          <button matButton matStepperPrevious (click)="previousStep()" style="
                              width: 100px;
                              height: 39px;
                              color: #4d5258;
                              font-weight: 500;
                              border-radius: 5px;
                              border: 1px solid #c1c6cd;
                              background-color: #ffffff;
                              margin-right: 10px;
                            ">
                            <img src="/assets/images/leftarrow.svg" alt="arrow" style="margin-right: 5px" />Back
                          </button>
                          <button disabled (click)="nextStep()" matButton matStepperNext style="
                              width: 100px;
                              height: 39px;

                              font-weight: 500;
                              border-radius: 5px;
                              color: #d2d3d5;
                              border: 1px solid #e0e2e6;
                              background-color: #ffffff;
                              margin-right: 10px;
                            ">
                            Next<img src="/assets/images/arrow-right 1.svg" alt="arrow" style="margin-left: 5px" />
                          </button>

                          <button [disabled]="checkFormValidity()" (click)="nextStep()" matButton matStepperNext
                            [ngStyle]="{
                              color: checkFormValidity() ? '#888888' : 'black',
                              cursor: checkFormValidity()
                                ? 'not-allowed'
                                : 'pointer',
                              backgroundColor: checkFormValidity()
                                ? '#e0e0e0'
                                : '#ffbc0f',
                              borderColor: '#c1c6cd',
                              fontWeight: 'bold',
                              float: 'right',
                              width: '100px',
                              height: '39px',
                              padding: '4px 16px',
                              borderRadius: '5px',
                              border: 'none',
                            }">
                            Review
                          </button>
                        </div>
                      </div>
                    </mat-step>

                    <mat-step>
                      <ng-template matStepLabel>Preview</ng-template>
                      <div style="padding: 24px">
                        <div class="review-page-container">
                          <!-- <div class="header"> -->
                          <!-- <div class="stamp">{{ data.stampText }}</div> -->
                          <!-- </div> -->
                          <div style="
                              display: flex;
                              justify-content: space-between;
                            ">
                            <div style="
                                width: 40%;
                                /* height: 463px; */
                                background-color: white;
                                border: 1px solid #ffebb7;
                                padding: 16px 24px 24px 24px;
                                border-radius: 8px;
                                align-content: center;
                                gap: 8px;
                              ">
                              <div style="
                                  width: 383px;
                                  height: 32px;
                                  /* border: 1px solid black; */
                                  margin-bottom: 10px;
                                ">
                                <img *ngIf="lastPageSupplier?.attachmentContent" [src]="
                                    'data:image/jpeg;base64,' +
                                    lastPageSupplier.attachmentContent
                                  " style="
                                    /* width: 100%; */
                                    height: 100%;
                                    object-fit: contain;
                                    border-radius: 4px;
                                  " />
                              </div>
                              <div style="
                                  /* width: 363px; */
                                  height: 363px;

                                  margin: auto;
                                ">
                                <img src="{{
                                    equipmentStandard.imageAttachmentContentAsBase64
                                  }}" style="
                                    width: 100%;
                                    height: 100%;
                                    object-fit: cover;
                                    border-radius: 4px;
                                  " />
                              </div>
                            </div>

                            <div class="info-main" style="width: 59%">
                              <div>
                                <h1 class="lastpage-title" style="padding: 0px 10px 10px 0px">
                                  {{
                                  addEquipmentStandardForm.get("title")?.value
                                  }}
                                </h1>
                              </div>
                              <div class="info-section">
                                <!-- <div class="divider"></div> -->

                                <div class="info-column right-column">
                                  <div class="info-row">
                                    <span class="reviewPage-icon date"></span>
                                    <span class="label">Approved For Use</span>
                                    <span class="value">{{
                                      addEquipmentStandardForm.get(
                                      "effectiveFrom"
                                      )?.value | date: "dd, MMM yyyy"
                                      }}</span>
                                  </div>

                                  <div class="info-row">
                                    <span class="reviewPage-icon date2"></span>
                                    <span class="label">Obsolete Date</span>
                                    <span class="value">{{
                                      addEquipmentStandardForm.get(
                                      "obsoleteDate"
                                      )?.value | date: "dd, MMM yyyy"
                                      }}</span>
                                  </div>

                                  <div class="info-row">
                                    <span class="reviewPage-icon equipmentType"></span>
                                    <span class="label">Equipment Type</span>
                                    <span class="value">{{
                                      lastPageEquipmentType
                                      }}</span>
                                  </div>

                                  <div class="info-row">
                                    <span class="reviewPage-icon model"></span>
                                    <span class="label">Model</span>
                                    <span class="value">{{
                                      addEquipmentStandardForm.get("model")
                                      ?.value
                                      }}</span>
                                  </div>

                                  <div class="info-row">
                                    <span class="reviewPage-icon supplier"></span>
                                    <span class="label">Supplier</span>
                                    <span class="value">{{
                                      lastPageSupplier?.name
                                      }}</span>
                                  </div>

                                  <div class="info-row">
                                    <span class="reviewPage-icon standardType"></span>
                                    <span class="label">Equipment Class</span>
                                    <span class="value">{{
                                      selectedEquipmentClass
                                      }}</span>
                                  </div>

                                  <div class="info-row">
                                    <span class="reviewPage-icon location"></span>
                                    <span class="label">Location</span>
                                    <span class="value">{{
                                      selectedLocationNames
                                      }}</span>
                                  </div>

                                  <div class="info-row">
                                    <span class="reviewPage-icon Sublocation"></span>
                                    <span class="label">Sub Location</span>
                                    <span class="value">{{
                                      subLocationselected != ""
                                      ? lastPageSublocation
                                      : "--"
                                      }}</span>
                                  </div>

                                  <div class="info-row">
                                    <span class="reviewPage-icon createdOn"></span>
                                    <span class="label">Created On</span>
                                    <span class="value">{{
                                      createdOn | date: "dd, MMM yyyy"
                                      }}</span>
                                  </div>

                                  <!-- <div class="info-row">
                                <span class="icon user-icon"></span>
                                <span class="label">Key Contact</span>
                                <span class="value">{{ data.keyContact }}</span>
                              </div> -->
                                </div>
                              </div>
                            </div>
                          </div>

                          <div class="description-section">
                            <div style="
                                display: flex;
                                align-items: center;
                                align-content: center;
                              ">
                              <h2 class="section-title">Description</h2>
                              <button class="copyIcon">
                                <img (click)="
                                    copyText(
                                      addEquipmentStandardForm.get(
                                        'description'
                                      ).value
                                    );
                                    $event.stopPropagation()
                                  " src="../../assets/images/copy text.svg" alt="" />
                              </button>
                            </div>
                            <p class="description-text">
                              {{
                              addEquipmentStandardForm.get("description")
                              ?.value
                              }}
                            </p>
                          </div>

                          <div class="details-section" style="margin-top: 20px">
                            <div class="details-header" (click)="toggleDetails()">
                              <div class="details-title-wrapper">
                                <div>
                                  <span class="toggle-icon">
                                    <img *ngIf="!detailsExpanded" src="../../assets/images/s-add 1.svg" alt="Expand"
                                      style="margin-bottom: 3px" />
                                    <img *ngIf="detailsExpanded" style="margin-bottom: 3px"
                                      src="../../assets/images/cross (2).svg" alt="Collapse" /></span>
                                  <!-- <span class="details-icon">☑</span> -->
                                  <span class="details-title"> Details </span>
                                </div>
                                <div *ngIf="detailsExpanded">
                                  <img (click)="
                                      copyText(
                                        addEquipmentStandardForm.get('note')
                                          .value
                                      );
                                      $event.stopPropagation()
                                    " src="../../assets/images/copy text.svg" alt="" />
                                </div>
                              </div>
                            </div>

                            <div class="details-content" [class.expanded]="detailsExpanded">
                              <div [innerHTML]="getDetails()" class="detail-section"></div>
                            </div>
                          </div>

                          <div class="bottom-sections">
                            <div class="resources-section" *ngIf="hasResourceUrls">
                              <div class="section-header">
                                <h2 class="section-heading">
                                  Resources and Supporting Information
                                </h2>
                                <span class="info-icon-circle">?</span>
                              </div>
                              <div class="links-list" formArrayName="resourceLinks1">
                                <a *ngFor="
                                    let resource of resourceLinks1.controls;
                                    let i = index
                                  " [formGroupName]="i" [href]="resource.get('url')?.value" class="resource-link">
                                  {{ resource.get("title")?.value }}
                                </a>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div style="margin-top: 40px">
                          <button [disabled]="checkFormValidity()" matButton (click)="previousStep()" matStepperPrevious
                            style="
                              width: 100px;
                              height: 39px;
                              color: #4d5258;
                              font-weight: 500;
                              border-radius: 5px;
                              border: 1px solid #c1c6cd;
                              background-color: #ffffff;
                              margin-right: 10px;
                            ">
                            <img src="/assets/images/leftarrow.svg" alt="arrow" style="margin-right: 5px" />Back
                          </button>
                          <button disabled matButton matStepperNext style="
                              width: 100px;
                              height: 39px;
                              font-weight: 500;
                              border-radius: 5px;
                              color: #d2d3d5;
                              border: 1px solid #e0e2e6;
                              background-color: #ffffff;
                              margin-right: 10px;
                            ">
                            Next<img src="/assets/images/arrow-right 1.svg" alt="arrow" style="margin-left: 5px" />
                          </button>

                          <button [disabled]="checkFormValidity()" (click)="save()" matButton [ngStyle]="{
                              color: checkFormValidity() ? '#888888' : 'black',
                              cursor: checkFormValidity()
                                ? 'not-allowed'
                                : 'pointer',
                              backgroundColor: checkFormValidity()
                                ? '#e0e0e0'
                                : '#ffbc0f',
                              borderColor: '#c1c6cd',
                              fontWeight: 'bold',
                              float: 'right',
                              padding: '4px 16px',
                              width: '100px',
                              height: '39px',
                              borderRadius: '5px',
                              border: 'none',
                            }">
                            Submit
                          </button>
                        </div>
                      </div>
                    </mat-step>
                  </mat-stepper>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- <div class="mcd-upload-images">
          <div class="row attachements">
            <div class="col">
              <a href="javascript:void(0);" (click)="equipmentImage.click()">
                <span>
                  <img
                    alt="Upload Image"
                    src="/assets/images/attachement.svg"
                  />
                </span>
                Upload Image (JPEG, PNG, BMP)
              </a>
              <mat-label
                *ngIf="
                  equipmentStandard.imageAttachment?.fileName && isEditMode
                "
                >Image File</mat-label
              >
              <div class="uploaded-file">
                <span class="file-name">
                  <a
                    href="javascript:void(0);"
                    (click)="
                      onDownloadSelectedImage(
                        equipmentStandard?.imageAttachment?.id
                      )
                    "
                    >{{ equipmentStandard.imageAttachment?.fileName }}</a
                  >
                </span>
                <span *ngIf="equipmentStandard.imageAttachment?.fileName">
                  <a href="javascript:void(0);" (click)="onRemoveImage()">
                    <i class="material-icons delete-icon"> cancel </i>
                  </a>
                </span>
              </div>
              <input
                hidden
                type="file"
                (change)="onSelectImage($event)"
                #equipmentImage
              />
              <mat-error class="mat-error-left-label" *ngIf="invalidImage">
                Invalid file type.
              </mat-error>
              <mat-error class="mat-error-left-label" *ngIf="invalidImageRes">
                Invalid image resolution.
              </mat-error>
            </div>

            <div class="col text-right">
              <a href="javascript:void(0);" (click)="equipmentDoc.click()">
                <span>
                  <img
                    alt="Upload Image"
                    src="/assets/images/attachement.svg"
                  />
                </span>
                Attach File (doc, docx, pdf)
              </a>
              <mat-label
                *ngIf="
                  equipmentStandard.equipmentAttachment?.fileName && isEditMode
                "
                >Attachment</mat-label
              >
              <div class="uploaded-file qr-code">
                <span class="file-name">
                  <a
                    href="javascript:void(0);"
                    (click)="
                      onDownloadSelectedAttachment(
                        equipmentStandard.equipmentAttachment
                      )
                    "
                    >{{ equipmentStandard.equipmentAttachment?.fileName }}</a
                  >
                </span>
                <span *ngIf="equipmentStandard.equipmentAttachment?.fileName">
                  <a href="javascript:void(0);" (click)="onRemoveAttachment()">
                    <i class="material-icons delete-icon"> cancel </i>
                  </a>
                </span>
              </div>
              <input
                hidden
                type="file"
                (change)="onSelectAttachment($event)"
                #equipmentDoc
              />
              <mat-error
                class="mat-error-right-label"
                *ngIf="invalidAttachment"
              >
                Invalid file type.
              </mat-error>
            </div>
          </div>
        </div> -->
      </form>
    </mat-card-content>
    <!-- <mat-card-footer class="mcd-card-footer">
      <button
        class="mcd-btn mcd-btn-primary"
        *ngIf="!equipmentStandard.id"
        mat-raised-button
        (click)="resetForm()"
      >
        Reset
      </button>
      <button
        class="mcd-btn mcd-btn-primary"
        *ngIf="equipmentStandard.id > 0"
        mat-raised-button
        (click)="onBackClickorEditRedirect()"
      >
        Back
      </button>
      <button
        class="mcd-btn mcd-btn-secondary"
        mat-raised-button
        [disabled]="checkFormValidity()"
        (click)="save()"
        *ngIf="!isEditMode"
      >
        Add
      </button>
      <button
        class="mcd-btn mcd-btn-secondary"
        mat-raised-button
        [disabled]="checkFormValidity()"
        (click)="save()"
        *ngIf="isEditMode"
      >
        Update
      </button>
    </mat-card-footer> -->
  </div>
</mat-card>
<app-mcd-loader class="mcd-page-loader" *ngIf="loading"></app-mcd-loader>